import { Phone, PhoneCall, Users, Shield } from "lucide-react";

const Section = () => {
  return (
    <section className="pt-24 pb-16 px-6 bg-gradient-to-br from-green-50 to-cyan-50">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
        
        {/* Text Content */}
        <div className="space-y-6">
          <h1 className="text-5xl lg:text-6xl font-bold leading-tight text-slate-800">
            Komunikasi Bisnis{" "}
            <span className="bg-gradient-to-r from-green-600 to-cyan-500 bg-clip-text text-transparent">
              Lebih Efisien
            </span>
          </h1>
          <h2 className="text-2xl text-slate-600">dengan IP Phone</h2>
          <p className="text-lg text-slate-500 leading-relaxed max-w-md">
            Layanan telepon berbasis internet dengan fitur lengkap untuk perusahaan modern
          </p>

          <button className="group bg-gradient-to-r from-green-600 to-cyan-500 hover:from-green-700 hover:to-cyan-600 px-8 py-4 rounded-xl font-semibold text-lg text-white transition-all duration-300 transform hover:scale-105 hover:shadow-2xl">
            Hubungi Kami
          </button>
        </div>

        {/* Feature Cards with large background illustration */}
        <div className="relative">
          {/* Background Illustration */}
          <img
            src="/image/people.png"
            alt="IP Phone Illustration"
            className="absolute inset-0 w-[150%] h-[150%] object-contain opacity-25 -translate-x-1/4 -translate-y-1/4 pointer-events-none"
          />

          {/* Cards Grid */}
          <div className="relative grid grid-cols-2 gap-6 p-6 mt-[240px]">
            <div className="bg-gradient-to-br from-green-100 to-cyan-100 rounded-2xl p-6 shadow-md">
              <Phone className="w-10 h-10 text-green-600 mb-4" />
              <h3 className="text-lg font-semibold text-slate-800">IP Phone</h3>
              <p className="text-sm text-slate-600">Perangkat telepon digital</p>
            </div>
            <div className="bg-gradient-to-br from-green-100 to-emerald-100 rounded-2xl p-6 shadow-md">
              <PhoneCall className="w-10 h-10 text-green-600 mb-4" />
              <h3 className="text-lg font-semibold text-slate-800">HD Voice</h3>
              <p className="text-sm text-slate-600">Kualitas suara jernih</p>
            </div>
            <div className="bg-gradient-to-br from-purple-100 to-pink-100 rounded-2xl p-6 shadow-md">
              <Users className="w-10 h-10 text-purple-600 mb-4" />
              <h3 className="text-lg font-semibold text-slate-800">Multi User</h3>
              <p className="text-sm text-slate-600">Banyak extension</p>
            </div>
            <div className="bg-gradient-to-br from-orange-100 to-red-100 rounded-2xl p-6 shadow-md">
              <Shield className="w-10 h-10 text-orange-600 mb-4" />
              <h3 className="text-lg font-semibold text-slate-800">Secure</h3>
              <p className="text-sm text-slate-600">Enkripsi tingkat tinggi</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section;